import type { NotificationJobModuleCardProps } from "./notification-job-module-card.type";

import { ExclamationCircleOutlined, FileTextOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import { Trans, useTranslation } from "react-i18next";

import { HelpCenterLink } from "@/modules/help-center";
import { JobModuleActionLink } from "@/modules/job-module/job-module-action-link";
import { NotificationCard } from "@/modules/notification/notification-card";
import { useNotificationsPanel } from "@/modules/notifications/notifications-panel";
import { OrganizationContextLabel } from "@/modules/organization/organization-context-label";

const { Paragraph } = Typography;

export const NotificationJobModuleCard = ({
  notification,
}: NotificationJobModuleCardProps) => {
  const { t } = useTranslation();
  const { closePanel } = useNotificationsPanel();

  const context = notification.data.context;
  const moduleName = notification.data.job_module.module_name;
  const subject = notification.data.job_module.subjects[0];
  const isFailed = notification.type === "job-module-failed";

  const status = isFailed ? "failed" : "completed";
  const color = isFailed ? "var(--app-color-error)" : "#722ed1";
  const Icon = isFailed ? ExclamationCircleOutlined : FileTextOutlined;

  return (
    <NotificationCard
      notification={notification}
      icon={<Icon style={{ color }} />}
      title={t(`notification:jobModule.${status}.title`, { moduleName })}
      color={color}
      content={
        <Paragraph>
          <Trans
            i18nKey={`notification:jobModule.${status}.description`}
            values={{ moduleName, subjectName: subject.name }}
            components={{ strong: <strong />, em: <em /> }}
          />
        </Paragraph>
      }
      actions={
        <>
          <JobModuleActionLink
            customContext={context}
            subject={subject}
            showIcon="external"
            onClick={closePanel}
          />
          {isFailed && (
            <HelpCenterLink shortText withIcon onClick={closePanel} />
          )}
          <OrganizationContextLabel context={context} isSmall />
        </>
      }
    />
  );
};
